import React from "react";
import { Segment } from "semantic-ui-react";
import PropTypes from "prop-types";
import { Trans } from "react-i18next";
import { Button } from '@weezevent/nacre';


export default function ButtonGroup({
    onNew,
    onReset,
    onTrigger,
}) {
    return(
        <Segment basic textAlign='center'>
            { onNew
                ? <Button primary onClick={ onNew } >
                    <Trans i18nKey="nacre.ImportController.buttons.import_new">Import a new file</Trans>
                </Button>
                : null }
            { onReset
                ? <Button inverted onClick={ onReset }>
                    <Trans i18nKey="nacre.ImportController.buttons.cancel_button" >Cancel</Trans>
                </Button>
                : null }
            { onTrigger !== undefined
                ? <Button primary onClick={ onTrigger } disabled={ onTrigger === null } >
                    <Trans i18nKey="nacre.ImportController.buttons.validate_button" >Import</Trans>
                </Button>
                : null }
        </Segment>
    );
}

ButtonGroup.propTypes = {
    onNew: PropTypes.func,
    onReset: PropTypes.func,
    onTrigger: PropTypes.func,
};
